var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-search",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.997,16.141l-4.276-4.276c-1.158,0.904-2.581,1.401-4.084,1.401c-1.767,0-3.433-0.69-4.693-1.939c-1.249-1.25-1.94-2.916-1.94-4.693c0-1.777,0.691-3.443,1.94-4.693C3.204,0.691,4.87,0,6.637,0c1.778,0,3.443,0.691,4.693,1.94c1.259,1.25,1.95,2.916,1.95,4.693c0,1.503-0.508,2.926-1.412,4.084l4.276,4.276L14.997,16.141z M6.637,11.651 c1.341,0,2.601-0.519,3.556-1.474c0.944-0.944,1.463-2.204,1.463-3.545s-0.519-2.6-1.463-3.555C9.237,2.133,7.978,1.615,6.637,1.615 s-2.6,0.518-3.545,1.462C2.137,4.033,1.619,5.292,1.619,6.633s0.518,2.601,1.462,3.545C4.037,11.133,5.296,11.651,6.637,11.651z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.15e26bf184aa41b900490963e6cb1127.svg";
export { ForwardRef as ReactComponent };